export default (string: string) => {
  if (string.includes('_')) {
    const [first, sec] = string.split('_');
    return first + sec.charAt(0).toUpperCase() + sec.slice(1);
  }
  return string;
};
